import React from "react";

import { PageLayout } from "../components/PageLayout";

export default function TermsPage() {
  return (
    <PageLayout title="Terms of Use">
      <div className="container max-w-3xl py-12 space-y-8">
        <h1 className="text-3xl font-bold">Terms of Use</h1>
        <section className="space-y-4 text-muted-foreground">
          <p>
            These Terms of Use ("Terms") govern your use of SnapNote ("the
            Service"). By accessing or using the Service, you agree to be bound
            by these Terms.
          </p>
          <h2 className="text-xl font-semibold text-foreground">
            Use of Service
          </h2>
          <p>
            You may use the Service only in compliance with applicable laws and
            these Terms. You are responsible for your conduct and content while
            using the Service.
          </p>
          <h2 className="text-xl font-semibold text-foreground">Disclaimer</h2>
          <p>
            The Service is provided "as is" without warranties of any kind. We
            are not liable for any damages arising from your use of the Service.
          </p>
          <h2 className="text-xl font-semibold text-foreground">
            Changes to Terms
          </h2>
          <p>
            We may update these Terms from time to time. We will notify you of
            any changes by posting the new Terms on this page.
          </p>
        </section>
      </div>
    </PageLayout>
  );
}
